import ShowOrder from "../ShowOrder";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import swal from "sweetalert2";
import axios from "axios";
import { AppService } from "../../../services/appService";
import barramento from "../../../barramento";

export default {
  props: {
    tab: {
      type: String,
    },
    endOrders: {
      type: null
    },
    isLoading: {
      type: null
    },
    loadingOrder: {
      type: null
    },
    items: {
      type: null
    },
    orders: {
      type: Array,
      default: () => []
    },
    status: {
      type: String,
      default: "all"
    },
    filtro: {
      type: String,
      default: null
    },
    sub_filtro: {
      type: String,
      default: null
    },
    scroll: {
      //type: Function
    },
    notaFiscal: {
      default: false
    },
    method: {},
    count: {}
  },
  components: {
    ShowOrder
  },

  data() {
    return {
      filters: {
        ID: null,
        channel: null,
        created: null,
        name: null,
        surname: null,
        status: null,
        sub_status: null,
        total: null,
      },
      status_entregue: false,

      checkedOrders: [],

      orderToShow: null,

      index: null,
      //items: [],

      statusOptions: [
        { text: "Selecione", value: null },
        "Aprovado",
        "Pendente",
        "Cancelado"
      ]
    };
  },
  beforeDestroy() {
    barramento.$off('orders_action_status')
  },
  created() {
    barramento.$on('orders_action_status', status => {
      if (status) {
        var bkpChecked = this.checkedOrders;
        this.selectAllOrders = false;
        for (var i = 0; i < this.orders.length; i++) {
          if (this.orders[i].status == 'Em Transito') {
            for (var j = 0; j < bkpChecked.length; j++) {
              if (this.orders[i].id == bkpChecked[j]) {
                this.checkedOrders.push(bkpChecked[j]);
              }
            }
          }
        }
      }
      this.status_entregue = status;
    });
  },
  watch: {
    //filtred data não existe em lugar nenhum!
    /*
    orders: value => {
      this.filteredData = value;
    },
    */

    checkedOrders: {
      handler: function (oldValues, newValue) {
        this.addOrderToActionList(oldValues);
      },
      deep: true
    },

    isLoading: {
      handler: function (oldValues, newValue) {
        this.checkedOrders = [];
      },
    }
  },

  computed: {
    selectAllOrders: {
      get: function () {
        return this.orders
          ? this.checkedOrders.length == this.orders.length
          : false;
      },
      set: function (value) {
        let selected = [];
        if (value) {
          this.orders.forEach(order => selected.push(order.id));
        }
        this.checkedOrders = selected;
      }
    }
  },

  methods: {
    ...mapActions({
      addOrderToActionList: "addOrderToActionList"
    }),

    checkEtiqueta() {
      switch (this.filtro) {
        case 'approved':
        case 'invoiced':
        case 'shipping_informed':
        case 'shipping_error':
          return true;
        default:
          return false;
      }
    },

    getAppNameByClientID(clientID) {
      if (clientID) {
        return AppService.getNameOfAppByClientID(clientID);
      }
    },

    transformExternal(object) {
      let arr = [];

      if (object && typeof object === 'object') {
        for (let key in object) {
          arr.push({
            app: AppService.getNameOfAppByClientID(key), // key is client_id
            external: object[key]
          });
        }
      }

      return arr;
    },

    parseID(external) {
      if (external && typeof external === 'string') {
        let match = external.match(',');
        if (match && match.index) {
          return external.slice(0, match.index) + '...';
        }
      }

      return external;
    },

    showOrder(index) {
      barramento.$emit('orders_status_buttons_export', false);
      this.orderToShow = this.orders[index];
      this.$store.commit("ORDER_OBJECT", this.orderToShow);
      this.index = index;
    },

    infiniteHandler() {
      this.$emit('infiniteHandler');
    },

    back(value) {
      this.orderToShow = value;
    },

    formatCurrency(value) {
      return Intl.NumberFormat("pt-br", {
        currency: "BRL",
        style: "currency"
      }).format(value);
    },

    hasSLAExpired(item) {
      if (
        item.status === 'Em Transito'
      ) {
        let orderSLA = moment(item.expected_delivery_date);
        let today = moment();

        if (today.diff(orderSLA, "days") >= 1) {
          return 'sla-expired';
        }
      }
    },

    formatStatusBadge(stats) {
      if (stats === undefined || stats == null) {
        return "";
      }


      let status = stats.toLowerCase();

      switch (status) {
        case "pendente":
          return "info";
        case "aprovado":
        case "pago":
          return "success";
        case "erro ao gerar nota fiscal":
        case "erro ao enviar entrega":
          return "danger";
        case "cancelado":
          return "dark";
        default:
          return "primary";
      }
    },

    get_print_html(tag, key) {


      var icon;
      var link;
      var name;
      var title;

      //1 - tem, 2 - foi impresso, null ou 0 - não tem
      if (key == 1) {
        title = this.$t("Disponível para impressão");
        icon = '<i class="fas fa-print" title="' + title + '"></i>';
      }

      if (key == 2) {
        title = this.$t("Impresso");
        icon = '<i class="fa fa-check text-green" title="' + title + '"></i>';
      }
      if (key == null || key == 0) {
        //etiqueta sempre vai estar habilitada para impressão
        if (tag == "has_label") {
          title = this.$t("Disponível para impressão");
          icon = '<i class="fas fa-print" title="' + title + '"></i>';
        } else {
          title = this.$t("Documento não gerado pelo sistema");
          icon = 'sla-expired'
          '<i class="fa fa-times text-danger" title="' + title + '"></i>';
        }
      }
      name = this.$t(tag);
      return icon + "&nbsp;" + name + "&nbsp;&nbsp;&nbsp;";
    },

    print(tag, key, item) {
      if (tag == "has_label") {
        //chama impressão de etiqueta
        var id = [item.id];
        this.print_labels(id);
      } else {
        //outros documentos
        if (key == null || key == 0) {
          swal({
            title: "Ops!",
            text: this.$t(
              "Este pedido não possui este documento gerado pelo sistema"
            )
          });
        } else {
          var id = [
            {
              id: item.id,
              shipments: item.shipments
            }
          ];

          if (tag == "has_invoice_doc") {
            this.print_nfes(id);
          }

          if (tag == "has_gnre_doc") {
            this.print_gnres(id);
          }
        }
      }
    },

    print_nfes(orders_ids) {
      axios
        .post("/api/documents/get_nfes", orders_ids)
        .then(response => {
          if (response.data.erro) {
            swal({
              title: "Ops!",
              /*text: this.$t(
                "Ocorreu algum problema ao tentar gerar as notas fiscais, tente novamente em alguns instantes."
              ),*/
              text: this.$t(response.data.erro),
              type: "error"
            });
          } else {
            let link = document.createElement("a");
            link.setAttribute("href", response.data.file);
            link.setAttribute("download", response.data.file);
            link.setAttribute("target", "_blank");
            link.style.display = "none";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.method();
            swal({
              title: this.$t("Pronto!"),
              text: this.$t("Notas fiscais geradas com sucesso!"),
              type: "success"
            });
          }
        })
        .catch(error => {
          swal({
            title: "Ops!",
            text: this.$t(
              "Ocorreu algum problema ao tentar gerar as notas fiscais, tente novamente em alguns instantes."
            ),
            type: "error"
          });
        });
    },

    formatDate(value, loc = null) {
      if (value) {
        if (loc !== "US") {
          let date = moment(String(value)).format("DD/MM/YYYY HH:mm:ss");

          if (date === 'Invalid date') {
            return value
          }

          return date;
        } else {
          return moment(String(value)).format("YYYY-MM-DD HH:mm:ss");
        }
      }
    },

    print_gnres(orders_ids) {
      axios
        .post("/api/documents/get_gnres", orders_ids)
        .then(response => {
          if (response.data.erro) {
            swal({
              title: "Ops!",
              /*text: this.$t(
                "Ocorreu algum problema ao tentar gerar as GNREs, tente novamente em alguns instantes."
              ),*/
              text: this.$t(response.data.erro),
              type: "error"
            });
          } else {
            let link = document.createElement("a");
            link.setAttribute("href", response.data.file);
            link.setAttribute("download", response.data.file);
            link.setAttribute("target", "_blank");
            link.style.display = "none";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.method();
            swal({
              title: this.$t("Pronto!"),
              text: this.$t("GNREs geradas com sucesso!"),
              type: "success"
            });
          }
        })
        .catch(error => {
          swal({
            title: "Ops!",
            text: this.$t(
              "Ocorreu algum problema ao tentar gerar as GNREs, tente novamente em alguns instantes."
            ),
            type: "error"
          });
        });
    },

    print_labels(orders_ids) {
      axios
        .post("/api/documents/get_labels", orders_ids)
        .then(response => {
          if (response.data.urls) {
            response.data.urls.forEach(function (pdf_link) {
              let link = document.createElement("a");
              link.setAttribute("href", pdf_link);
              link.setAttribute("download", pdf_link);
              link.setAttribute("target", "_blank");
              link.style.display = "none";
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            });
          } else {
            if (response.data.error) {
              if (response.data.error.orders) {
                var text = this.$t(
                  "Ocorreu algum problema ao tentar gerar as etiquetas do(s) pedido(s)"
                );

                for (var key in response.data.error.orders) {
                  text = text + "<br><br>" + this.$t("Pedido") + " " + key;
                  for (var key2 in response.data.error.orders[key]) {
                    text =
                      text + "<br>" + response.data.error.orders[key][key2];
                  }
                }
              }
              if (response.data.error.config) {
                var text = this.$t(
                  "Ocorreu algum problema ao tentar gerar as etiquetas"
                );

                text =
                  text +
                  "<br><br>" +
                  this.$t("Clique") +
                  ' <a href="http://beta.plugg.to/settings#labels" target="_parent">' +
                  this.$t("aqui") +
                  " <a> " +
                  this.$t("para configurar o formato de impressão") +
                  ".";
              }

              swal({
                title: "Ops!",
                html: text,
                type: "error"
              });
            } else {
              swal({
                title: "Ops!",
                text: this.$t(
                  "Ocorreu algum problema ao tentar gerar as etiquetas do pedido, tente novamente em alguns instantes."
                ),
                type: "error"
              });
            }
          }
        })
        .catch(error => {
          swal({
            title: "Ops!",
            text: this.$t(error.response.data),
            type: "error"
          });
        });
    },

    changeStatus(id, index, status, sub_status) {
      //item.order_id, index, 'picking', 'pending_invoice'

      let ids = [{ id: id, status: status, sub_status: sub_status }];
      this.$http
        .post("/api/orders/updatestatus", ids)
        .then(response => {
          //let ids = response.data.join(", ");
          if (response.data.length) {
            swal(
              "Ops",
              this.$t(
                "Não foi possivel alterar o status dos pedido tente novamente em alguns instantes."
              )
              //"warning"
            );
            return;
          }
          if (status == "picking" && sub_status == "processing_picking") {
            this.exportPicking(id);
          } else {
            this.method();
            this.count();
          }
        })
        .catch(error => {
          swal(
            "Ops!",
            this.$t(
              "Não foi possivel alterar o status dos pedido tente novamente em alguns instantes."
            )
            //"warning"
          );
        });
    },

    exportPicking(id) {
      let data = {
        filtered: false,
        type: this.exportSelected2,
        ids: [id]
      };

      axios
        .post("/api/orders/export/picking", data)
        .then(success => {
          let link = document.createElement("a");
          link.setAttribute("href", success.data.file);
          link.setAttribute("download", success.data.file);
          link.setAttribute("target", "_blank");
          link.style.display = "none";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          swal({
            title: this.$t("Pronto!"),
            text: this.$t("Lista de picking gerada com sucesso!"),
            type: "success"
          });
          this.method();
          this.count();
        })
        .catch(error => {
          swal({
            title: "Ops!",
            text: this.$t(
              "Não foi possivel gerar a lista de picking, tente novamente em alguns instantes."
            )
          });
        });
    }
  }
};



// WEBPACK FOOTER //
// ./resources/assets/js/components/Orders/OrderList/orderList.js